module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-3"
  }, [_c('h2', [_c('trans', {
    attrs: {
      "msg": "step3_title"
    }
  })], 1), _vm._v(" "), _c('p', [_c('trans', {
    attrs: {
      "msg": "step3_description"
    }
  })], 1), _vm._v(" "), _c('label', [_c('trans', {
    attrs: {
      "msg": "step3_choose"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "color-wrapper"
  }, [_c('div', {
    class: _vm.invalid.indexOf('color') !== -1 ? 'error color-group' : 'color-group'
  }, [_c('color', {
    attrs: {
      "color": "#d0011b",
      "active_color": _vm.custom_color
    },
    on: {
      "activate": _vm.change_color
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "color": "#f6a623",
      "active_color": _vm.custom_color
    },
    on: {
      "activate": _vm.change_color
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "color": "#f8e81c",
      "active_color": _vm.custom_color
    },
    on: {
      "activate": _vm.change_color
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "color": "#222222",
      "active_color": _vm.custom_color
    },
    on: {
      "activate": _vm.change_color
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "color": "#bd0fe1",
      "active_color": _vm.custom_color
    },
    on: {
      "activate": _vm.change_color
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "color": "#4990E2",
      "active_color": _vm.custom_color
    },
    on: {
      "activate": _vm.change_color
    }
  }), _vm._v(" "), _c('color', {
    attrs: {
      "color": "#7ed321",
      "active_color": _vm.custom_color
    },
    on: {
      "activate": _vm.change_color
    }
  })], 1)]), _vm._v(" "), _c('p', [_c('trans', {
    attrs: {
      "msg": "step3_post"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9719274"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Step3.vue
// module id = 74
// module chunks = 0